<template>
	<div id="driver">
		<h2 class="h2top">DRIVER RECRUITMENT</h2>
		<h2 class="h2bottom">司机招募</h2>
		<div class="lineClass"></div>
		<img style="width:100%" v-lazy="'../../static/img/123.jpg'" alt="">
	</div>
</template>
<script>
export default {
data () {
return {}
},
created () {},
mounted () {}
}
</script>
<style scoped>
#driver{
	margin-top: 5vw;
}

</style>



// WEBPACK FOOTER //
// src/components/driver.vue